export default {
    resultadoBuscaTodosPerfis: {
        filtros: {
            conteudo: {
                default: null,
                label: 'Pesquisa',
                value: ''
            },
            empresaId: {
                default: null,
                value: ''
            }
        },
        paginacao: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 10,
            multiSort: false,
            mustSort: false,
            page: 1,
            rowsPerPage: 10,
            sortBy: ['id'],
            descending: false,
            sortDesc: [false],
            direction: 'DESC',
        }
    },
    rota: {
        origem: 'GerenciarPerfis'
    }
}
